import { Typography } from "@material-ui/core";
import { CompanyContactPersonDto, CurrencyIDs } from "Api/Api";
import { CompanyContactEditFormData } from "Components/Companies/CompanyContacts/CompanyContactEdit";
import { StyledError } from "Components/Companies/CompanyEdit/CompanyEditBasicInfo/CompanyEditBasicInfoStyles";
import { TooltipInfoIcon } from "Components/Shared/Icons";
import { DatePicker } from "Components/Shared/Inputs/DatePicker";
import { Dropdown } from "Components/Shared/Inputs/Dropdown";
import { TextInput } from "Components/Shared/Inputs/TextInput";
import { PrimaryTooltip } from "Components/Shared/PrimaryTooltip";
import * as React from "react";
import { UseFormMethods } from "react-hook-form";
import styled from "styled-components";
import { Resources, useResource } from "Translations/Resources";
import { nameof } from "Utils/ObjectUtils";

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
`;

const StyledTooltipWrapper = styled.div`
  display: inline-flex;
  margin-left: 5px;
  margin-top: 1px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

const StyledLabel = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  form: UseFormMethods<CompanyContactEditFormData>;
  isDisabled: () => boolean;
  person: CompanyContactPersonDto;
};

export const CompanyContactEditCharges: React.FunctionComponent<Props> = props => {
  const { form, isDisabled } = props;
  const { setValue, errors, watch } = form;
  const formValues = watch();
  const { t } = useResource();

  const getMinNewChargeDate = () => {
    const lastCharge = props.person.charges.find(x => !x.dateTo);
    return lastCharge ? new Date(lastCharge.dateFrom) : undefined;
  };
  const [minNewChargeDate] = React.useState(getMinNewChargeDate);

  return (
    <>
      <StyledWrapper>
        <div>
          <div>
            <StyledLabel>
              <label className={"form-label"} htmlFor={"manDayCharge"}>
                {t(Resources.CompanyEdit.ContactEdit.ManDayCharge.Label)}
              </label>
              <PrimaryTooltip
                placement={"top"}
                title={t(
                  Resources.CompanyEdit.ContactEdit.ManDayCharge.Tooltip,
                )}
              >
                <StyledTooltipWrapper>
                  <TooltipInfoIcon />
                </StyledTooltipWrapper>
              </PrimaryTooltip>
            </StyledLabel>
            <TextInput
              value={formValues.manDayCharge}
              name={nameof<CompanyContactEditFormData>("manDayCharge")}
              fieldError={errors.manDayCharge}
              mask={Number}
              disabled={isDisabled()}
              unmask={"typed"}
              onMaskInputChange={value => {
                setValue(
                  nameof<CompanyContactEditFormData>("manDayCharge"),
                  value,
                  {
                    shouldValidate: true,
                  },
                );
              }}
            />
          </div>
          {errors.manDayCharge && (
            <StyledError className={"error-manDayCharge"}>
              <Typography>{errors.manDayCharge?.message}</Typography>
            </StyledError>
          )}
        </div>

        <div>
          <DatePicker
            value={formValues.manDayChargeDateFrom}
            label={"Platná od"}
            minDate={minNewChargeDate}
            fieldError={errors.manDayChargeDateFrom}
            isDisabled={isDisabled()}
            format={"MM.yyyy"}
            views={["month", "year"]}
            onChange={val => {
              setValue(
                nameof<CompanyContactEditFormData>("manDayChargeDateFrom"),
                val ?? "",
              );
            }}
          ></DatePicker>
        </div>

        <div>
          <Dropdown
            label={"Měna"}
            value={formValues.currencyID ?? CurrencyIDs.CZK}
            options={[
              { value: CurrencyIDs.CZK, text: "Česká koruna (CZK)" },
              { value: CurrencyIDs.EUR, text: "Euro (EUR)" },
            ]}
            onChange={e => {
              setValue(
                nameof<CompanyContactEditFormData>("currencyID"),
                e.target.value as CurrencyIDs,
              );
            }}
          />
        </div>
      </StyledWrapper>
    </>
  );
};
